import request from '@/utils/request'

export default {
  getShareProfile(params) {
    return request.securePost('/h5/v1/resume/getShareProfile', params)
  },
  saveShareReview(data) {
    return request.securePost('/h5/v1/resume/saveShareReview', data)
  },
  resolveLocation(params) {
    return request.securePost('/h5/v1/resume/resolveLocation', params)
  },
  getShareOverview(params) {
    return request.securePost('/h5/v1/resume/getShareOverview', params)
  },
  getShareResume(params) {
    return request.securePost('/h5/v1/resume/getShareResume', params)
  },
  getShareJobInfo(params) {
    return request.securePost('/h5/v1/resume/getShareJobInfo', params)
  },
  getShareWorkExpList(params) {
    return request.securePost('/h5/v1/resume/getShareWorkExpList', params)
  },
  getShareProjectExpList(params) {
    return request.securePost('/h5/v1/resume/getShareProjectExpList', params)
  },
  getShareEducationList(params) {
    return request.securePost('/h5/v1/resume/getShareEducationList', params)
  },
  getShareCertList(params) {
    return request.securePost('/h5/v1/resume/getShareCertList', params)
  },
}
